import axiosInstanceNode from "../../../api/axiosInstanceNode";

// connect outlook - get auth URL
export const connectOutlook = async (data) => {
  try {
    const response = await axiosInstanceNode.post("/channel/unipile", data);
    return response.data;
  } catch (error) {
    console.error("Error connecting outlook:", error);
    throw error;
  }
};

// unipile connect - complete connection with accountId (after OAuth redirect)
export const unipileConnect = async ({ accountId }) => {
  try {
    const response = await axiosInstanceNode.post("/channel/unipile-connect", {
      accountId,
    });
    return response.data;
  } catch (error) {
    console.error("Error completing unipile connection:", error);
    throw error;
  }
};

// delete channel account
export const deleteChannel = async (accountId) => {
  try {
    const response = await axiosInstanceNode.delete(`/channel/${accountId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting channel:", error);
    throw error;
  }
};

// reconnect channel account - get hosted auth URL
export const reconnectChannel = async (accountId) => {
  try {
    const response = await axiosInstanceNode.post(`/channel/reconnect/${accountId}`);
    return response.data;
  } catch (error) {
    console.error("Error reconnecting channel:", error);
    throw error;
  }
};

// create channel
export const createChannel = async (data) => {
  try {
    const response = await axiosInstanceNode.post("/channel/create", data);
    return response.data;
  } catch (error) {
    console.error("Error creating channel:", error);
    throw error;
  }
};

// verify  channel
export const verifyChannel = async (data) => {
  try {
    const response = await axiosInstanceNode.post("/channel/verify", data);
    return response.data;
  } catch (error) {
    console.error("Error verifying channel:", error);
    throw error;
  }
};


// check channel status
export const checkChannelStatus = async (accountId) => {
  try {
    const response = await axiosInstanceNode.get(`/channel/check-status/${accountId}`);
  return response.data;
} catch (err) {
  console.error("Polling error", err);
  throw err;
}
};

// get my channels
export const getMyChannels = async () => {
  try {
    const response = await axiosInstanceNode.get("/channel/my");
    return response.data;
  } catch (err) {
    console.error("Error getting my channels:", err);
    throw err;
  }
};

export const searchBuyingSignals = async (data) => {
  try {
    const response = await axiosInstanceNode.post(
      "/linkedIn/buying-signals/search",
      data,
    );
    return response.data;
  } catch (err) {
    console.error("Error searching buying signals:", err);
    throw err;
  }
};

export const getBuyingSignalsUsage = async () => {
  try {
    const response = await axiosInstanceNode.get("/linkedIn/buying-signals/usage");
    return response.data;
  } catch (err) {
    console.error("Error getting buying signal usage:", err);
    throw err;
  }
};
